module.exports = __webpack_public_path__ + "img/page-25.cabdbc38.jpg";